//
//
//

import Model from "@/models/mobile";
export default {
  data() {
    return {
      code: ""
    };
  },
  methods: {
    onBridgeReady(_data, success, fail) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: _data.sub_appid, //公众号名称，由商户传入
          timeStamp: _data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: _data.nonceStr, //随机串
          package: _data.package,
          signType: _data.signType, //微信签名方式：
          paySign: _data.paySign //微信签名
        },
        res => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            if (success && typeof success === "function") success(res);
          } else {
            if (fail && typeof fail === "function") fail(res);
          }
        }
      );
    },
    async getCode() {
      let { data } = await Model.getCode({
        url: location.href.replace(/\//g, ",")
      });
      location.href = data;
    },
    async payByWx({ params, fail, paySuccess, payFail }) {
      let { data } = await Model.payByWx({
        ...params,
        code: this.code
      });
      if (data.success) {
        if (typeof WeixinJSBridge == "undefined") {
          //微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady(data.list, paySuccess, payFail),
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent(
              "WeixinJSBridgeReady",
              this.onBridgeReady(data.list, paySuccess, payFail)
            );
            document.attachEvent(
              "onWeixinJSBridgeReady",
              this.onBridgeReady(data.list, paySuccess, payFail)
            );
          }
        } else {
          this.onBridgeReady(data.list, paySuccess, payFail);
        }
      } else {
        if (fail && typeof fail === "function") fail(data);
      }
    },
    async payByZfb({ params, success, fail }) {
      if (!params.OrderDesc) {
        params.OrderDesc = "支付宝支付";
      }
      let { data } = await Model.payByZfb({
        ...params
        // OrderDesc: '支付宝支付'
      });
      if (data.success) {
        location.href = data.list.QRURL;
        if (success && typeof success === "function") success(data);
      } else {
        if (fail && typeof fail === "function") fail(data);
      }
    }
  },
  created() {
    if (this.$isWx) {
      if (!this.$route.query.code) {
        this.getCode();
      } else {
        this.code = this.$route.query.code;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/PayCommon.vue